
/** The single source of truth for in-app route paths. Every route literal lives here so the
 *  router table, the shell nav, and redirects all agree on one spelling. Feature/onboarding
 *  destinations that need a richer shape (see auth-callback's CALLBACK_DESTINATION) derive
 *  their values from these. */
export const PATHS = {
  home: '/',
  login: '/login',
  signup: '/signup',
  forgotPassword: '/forgot-password',
  account: '/me',
  listings: '/listings',
  newListing: '/listings/new',
  bookings: '/bookings',
  users: '/users',
  groupSettings: '/settings/group',
  onboarding: '/onboarding',
  setPassword: '/set-password',
  resetPassword: '/reset-password',
  authCallback: '/auth/callback',
} as const;
